import { ScorecardBaselineTableData, ScorecardDetails } from "../models/Scorecard";
import { colors } from "../styles/colors";
import { getValue } from "../utils";

export enum ScorecardConstants {
  PERFORMANCE_CRITERIA = "PERFORMANCE CRITERIA",
  WEIGHTED_SCORE = "WEIGHTED SCORE",
  CRITERIA_WEIGHT = "CRITERIA WEIGHT",
  KEY_PERFORMANCE_INDICATORS = "Key Performance Indicators",
  BRANCH_SCORE = "Branch Score",
  MAX_POINTS = "Max Points",
  ENGAGEMENT = "ENGAGEMENT",
  ENGAGEMENT_SCORE = "Engagement Score",
  REFERRAL_ACCEPTANCE_RATE = "Referral Acceptance Percentage",
  ENGAGEMENT_PERCENTAGE = "Engagement Percentage",
  PERCENTAGE_OF_REFERRAL_DISPOSITIONED_TIMELY = "Percentage of Referral Dispositioned Timely",
  QUALITY = "QUALITY",
  QUALITY_SCORE = "Quality Score",
  CARESTAT_COMPOSIT_SCORE = "Carestat Composit Score",
  TIMELY_START_OF_CARE_RATE = "Timely Start of Care Percentage",
  MEMBER_SATISFACTION_RATE = "Member Satisfaction Score",
  INTEROPERABILITY = "INTEROPERABILITY",
  INTEROPERABILITY_SCORE = "Interoperability Score",
  SHP_MATCH_RATE = "SHP Match Percentage",
  TOTAL_BRANCH_SCORE = "BRANCH SCORE",
  TOTAL_MAX_POINTS = "MAX POINTS",
  TOTAL_AVERAGE_SCORE = "FINAL WEIGHTED SCORE",
  TOTAL_SCORE_LABEL = "Total Score",
  TOTAL_POINTS_EARNED = "POINTS EARNED",
  POINTS_EARNED = "Points Earned",
  ACCEPTANCE_RATE = "Acceptance Rate",
  DISPOSITIONED_TIMELY = "Dispositioned Timely",
  ENGAGEMENT_RATE = "Engagement Rate",
  BASELINE_SHP_MATCH_RATE = "SHP Match Rate",
  CARESTAT_COMPOSITE_SCORE = "CareStat Composite Score",
  MEMBER_SATISFACTION = "Member Satisfaction",
  TIMELY_SOC = "Timely SOC",
}

export const getEngagementPerformanceCriteriaData = (
  scorecardData: ScorecardDetails | null
) => {
  const engagementPerformanceCriteriaData = {
    performanceCriteriaName: ScorecardConstants.ENGAGEMENT,
    progressScoreName: ScorecardConstants.ENGAGEMENT_SCORE,
    branchScoreTotal: getValue(scorecardData, "engagementBranchScoreTotal", 0),
    maxScoreTotal: getValue(scorecardData, "engagementMaxScoreTotal", 0),
    weightedScore: getValue(scorecardData, "engagementWeightedScore", ""),
    criteriaWeight: getValue(scorecardData, "engagementCriteriaWeight",""),
    pieScore: getValue(scorecardData, "engagementScore",""),
    keyPerformanceIndicator: [
      {
        indicatorName: ScorecardConstants.REFERRAL_ACCEPTANCE_RATE,
        branchScore: getValue(scorecardData, "acceptanceRate", 0),
        pointsEarned: getValue(scorecardData, "engagementRefAcceptRateBranchScore", 0),
        maxScore: getValue(scorecardData, "engagementRefAcceptRateMaxScore", 0)
      },
      {
        indicatorName: ScorecardConstants.ENGAGEMENT_PERCENTAGE,
        branchScore: getValue(scorecardData, "engagementRate", 0),
        pointsEarned: getValue(scorecardData, "engagementRateBranchScore", 0),
        maxScore: getValue(scorecardData, "engagementRateMaxScore", 0),
      },
      {
        indicatorName:
          ScorecardConstants.PERCENTAGE_OF_REFERRAL_DISPOSITIONED_TIMELY,
        branchScore: getValue(scorecardData, "dispositionedTimely", 0),
        pointsEarned: getValue(scorecardData, "engagementPerOfRefDisposTimelyBranchScore", 0),
        maxScore: getValue(scorecardData, "engagementPerOfRefDisposTimelyMaxScore", 0),
      },
    ],
  };
  return engagementPerformanceCriteriaData;
};

export const getQualityPerformanceCriteriaData = (
  scorecardData: ScorecardDetails | null
) => {
  const qualityPerformanceCriteriaData = {
    performanceCriteriaName: ScorecardConstants.QUALITY,
    progressScoreName: ScorecardConstants.QUALITY_SCORE,
    branchScoreTotal: getValue(scorecardData, "qualityBranchScoreTotal", 0),
    maxScoreTotal: getValue(scorecardData, "qualityMaxScoreTotal", 0),
    weightedScore: getValue(scorecardData, "qualityWeightedScore", ""),
    criteriaWeight: getValue(scorecardData, "qualityCriteriaWeight", ""),
    pieScore: getValue(scorecardData, "qualityScore", ""),
    keyPerformanceIndicator: [
      {
        indicatorName: ScorecardConstants.CARESTAT_COMPOSIT_SCORE,
        branchScore: getValue(scorecardData, "careStatComScore", 0),
        pointsEarned: getValue(scorecardData, "qualityCarestatCompositBranchScore", 0),
        maxScore: getValue(scorecardData, "qualityCarestatCompositMaxScore", 0),
      },
      {
        indicatorName: ScorecardConstants.TIMELY_START_OF_CARE_RATE,
        branchScore: getValue(scorecardData, "timelySOC", 0),
        pointsEarned: getValue(scorecardData, "qualityTimelyStartOfCareRateBranchScore", 0),
        maxScore: getValue(scorecardData, "qualityTimelyStartOfCareRateMaxScore", 0),
      },
      {
        indicatorName: ScorecardConstants.MEMBER_SATISFACTION_RATE,
        branchScore: getValue(scorecardData, "memberSatisfaction", 0),
        pointsEarned: getValue(scorecardData, "qualityMemberSatisfactionRateBranchScore", 0),
        maxScore: getValue(scorecardData, "qualityMemberSatisfactionRateMaxScore", 0),
      },
    ],
  };
  return qualityPerformanceCriteriaData;
};

export const getInterOperabilityPerformanceCriteriaData = (
  scorecardData: ScorecardDetails | null
) => {
  const interOperabilityPerformanceCriteriaData = {
    performanceCriteriaName: ScorecardConstants.INTEROPERABILITY,
    progressScoreName: ScorecardConstants.INTEROPERABILITY_SCORE,
    branchScoreTotal: getValue(scorecardData, "interoperabilityBranchScoreTotal", 0),
    maxScoreTotal: getValue(scorecardData, "interoperabilityMaxScoreTotal", 0),
    weightedScore: getValue(scorecardData, "interoperabilityWeightedScore", ""),
    criteriaWeight: getValue(scorecardData, "interoperabilityCriteriaWeight", ""),
    pieScore: getValue(scorecardData, "interoperabilityScore", ""),
    keyPerformanceIndicator: [
      {
        indicatorName: ScorecardConstants.SHP_MATCH_RATE,
        branchScore: getValue(scorecardData, "shpMatchRate", 0),
        pointsEarned: getValue(scorecardData, "interoperabilitySHPMatchRateBranchScore", 0),
        maxScore: getValue(scorecardData, "interoperabilitySHPMatchRateMaxScore", 0),
      },
    ],
  };
  return interOperabilityPerformanceCriteriaData;
};

export enum GetScorecardDetailsActionDispatchTypes {
  GET_SCORECARD_DETAILS_SUCCESS = "GET_SCORECARD_DETAILS_SUCCESS",
  GET_SCORECARD_DETAILS_ERROR = "GET_SCORECARD_DETAILS_ERROR",
  GET_SCORECARD_DETAILS_INVOKE = "GET_SCORECARD_DETAILS_INVOKE",
  GET_SCORECARD_DETAILS_RESET = "GET_SCORECARD_DETAILS_RESET",
}

export enum GetExcelActionDispatchTypes {
  GET_EXCEL_SUCCESS = "GET_EXCEL_SUCCESS",
  GET_EXCEL_ERROR = "GET_EXCEL_ERROR",
  GET_EXCEL_INVOKE = "GET_EXCEL_INVOKE",
  GET_EXCEL_RESET = "GET_EXCEL_RESET",
}

export const generatePieChartData = (label: string, pieScore: string | number) => {
  let value: number;
  if (typeof pieScore === "string") {
    value = parseFloat(pieScore) / 100;
  } else {
    value = pieScore;
  }
  const remainingValue = 1 - value;
  const pieChartData = [
    { label: label, value: value, color: colors.portalColor[30] },
    {
      label: ScorecardConstants.TOTAL_SCORE_LABEL,
      value: remainingValue,
      color: colors.white[1],
    },
  ];
  return pieChartData;
};

export enum ScorecardCriteria {
  SHP = "shpEnrolled",
  DINA = "dinaEnrolled",
  GOOD_STANDING = "inGoodStanding",
  EDI = "ediEnabled",
  ERA = "eraEnrolled",
  EFT = "eftEnrolled"
}

export const pushErrorMessages = (indicatorName: string) => {
  switch (indicatorName) {
    case ScorecardCriteria.DINA:
      return "Complete Portal and Referral Management Onboarding – This NPI is not configured in both ProNet Connect and Dina.";
    case ScorecardCriteria.SHP:
      return "Strategic Healthcare Programs (SHP) Enrolled – This NPI is not enrolled in Tango’s data sharing program.";
    case ScorecardCriteria.EDI:
      return "Clearinghouse Connected (EDI Enabled) – This NPI is not submitting electronic claims.";
    case ScorecardCriteria.EFT:
      return "Electronic Funds Transfer Enrolled (EFT Enrolled) – This NPI’s TIN is not receiving direct deposits.";
    case ScorecardCriteria.ERA:
      return "Electronic Remittance Advice Enrolled (ERA Enrolled) – This NPI’s TIN is not receiving electronic remittance.";
    case ScorecardCriteria.GOOD_STANDING:
      return "Stay in Good Standing with Credentialing – This NPI did not stay in good standing with credentialing documents during the selected performance period.";
  }
};

export const getScorecardKeys = (key: string) => {
  if (key === ScorecardCriteria.SHP ||
    key === ScorecardCriteria.DINA ||
    key === ScorecardCriteria.GOOD_STANDING ||
    key === ScorecardCriteria.EDI ||
    key === ScorecardCriteria.ERA ||
    key === ScorecardCriteria.EFT
  ) {
    return true;
  }
  return false;
}

export const XAxisLabel = 'NPI and its score (%)';

export const ModalHeader = 'Your Provider Scorecard is not displayed because the following required qualifiers have not been met:'

export const Disclaimer = 'Disclaimer : “If you believe this information is incorrect, please outreach to your dedicated Provider Relations Specialist.”'

export enum GetScorecardBaselineTableActionDispatchTypes {
  GET_SCORECARD_BASELINE_TABLE_SUCCESS = "GET_SCORECARD_BASELINE_TABLE_SUCCESS",
  GET_SCORECARD_BASELINE_TABLE_ERROR = "GET_SCORECARD_BASELINE_TABLE_ERROR",
  GET_SCORECARD_BASELINE_TABLE_INVOKE = "GET_SCORECARD_BASELINE_TABLE_INVOKE",
  GET_SCORECARD_BASELINE_TABLE_RESET = "GET_SCORECARD_BASELINE_TABLE_RESET",
}

type TableMetricConfig = {
    label: string;
    start: keyof ScorecardBaselineTableData;
    end: keyof ScorecardBaselineTableData;
};

type TableGroupConfig = {
    group: string;
    rows: TableMetricConfig[];
};

export const scorecardBaselineTableMetrics: TableGroupConfig[] = [
  {
    group: "Engagement",
    rows: [
      { label: ScorecardConstants.ACCEPTANCE_RATE, start: "acceptStart", end: "acceptEnd" },
      { label: ScorecardConstants.DISPOSITIONED_TIMELY, start: "timelyDispStart", end: "timelyDispEnd" },
      { label: ScorecardConstants.ENGAGEMENT_RATE, start: "engageStart", end: "engageEnd" },
    ],
  },
  {
    group: "Interoperability",
    rows: [
      { label: ScorecardConstants.BASELINE_SHP_MATCH_RATE, start: "oasisStart", end: "oasisEnd" },
    ],
  },
  {
    group: "Quality",
    rows: [
      { label: ScorecardConstants.CARESTAT_COMPOSITE_SCORE, start: "careStatStart", end: "careStatEnd" },
      { label: ScorecardConstants.MEMBER_SATISFACTION, start: "starRatingStart", end: "starRatingEnd" },
      { label: ScorecardConstants.TIMELY_SOC, start: "timelySOCStart", end: "timelySOCEnd" },
    ],
  },
];